// extracted by mini-css-extract-plugin
module.exports = {"tts-settings":"tts-settings_tts-settings__2HBhV"};